import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from 'components/Loading/Loading';
import RelatorioMapaEstatistico from './RelatorioMapaEstatistico';
//Api
import relatorio_api from '../../../api/relatorio_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
//Estado inicial dos filtros do relatorio
function initialStateFiltros() {
    return {
        dataFinal: "",
        tipo: "Diário",
        agrupamento: "GERADOR",
        nomeRelatorio: "Relatórios - Mapa Estatístico"
    }
}
export default function MapaEstatistico() {
    //Estado que valida os possiveis erros nos campos de filtros
    const [errors, setErrors] = useState({});
    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataFinal", required: true }),
    ]
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de tipo de relatorio
    const optionsTipoRelatorio = [
        { value: "Diário", text: "Diário" },
        { value: "Semanal", text: "Semanal" },
        { value: "Mensal", text: "Mensal" },
    ];

    //Opções de agrupamentos
    const optionsAgrupamento = [
        { value: "GERADOR", text: "Gerador" },
        { value: "LOCAL DE COLETA", text: "Local de coleta" },
        { value: "MODALIDADE", text: "Modalidade" },
        { value: "DESTINO", text: "Destino" },
        { value: "RESIDUO", text: "Residuo" },
    ];


    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Variavel de navegação na tela
    const navigate = useNavigate();

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        setErrors({});
        setLoading(true);
        relatorio_api.MapaEstatistico(filtros).then(response => {
            response.data?.itemsMapa?.map(value => {
                value.pesoTotalColetado = String(value.pesoTotalColetado).replace(".", ",") + " KG"
                return value
            })
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio != null) {
        return <RelatorioMapaEstatistico dadosRelatorio={dadosRelatorio} btnVoltar={() => setDadosRelatorio(null)} filtros={filtros} />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório de mapa estatístico</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data inicial"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="tipo" label={"Tipo Relatório"} type={"select"} value={filtros.tipo} invalid={!!errors.tipo} onChange={onChangeFiltros} options={optionsTipoRelatorio} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="agrupamento" label={"Agrupamento"} type={"select"} value={filtros.agrupamento} invalid={!!errors.agrupamento} onChange={onChangeFiltros} options={optionsAgrupamento} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}